import React, { useState, useEffect } from "react";
import styles from "./RegisterEmpresa.module.css";
import axiosInstance from "../../api/axiosConfig";
import { Link, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const RegisterEmpresa = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("businessRegistrationData");
    const initial = {
      reason_social: "",
      name: "",
      ruc: "",
      contact_person: "",
      charges: "",
      country: "",
      department: "",
      province: "",
      district: "",
      address: "",
      phone: "",
      email: "",
      website: "",
      password: "",
      confirm_password: "",
      termsAccepted: false,
      termsAcceptedAt: null,
    };
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.timestamp && parsed.data) {
          if (new Date().getTime() - parsed.timestamp < 10 * 60 * 1000) {
            return { ...initial, ...parsed.data };
          }
          localStorage.removeItem("businessRegistrationData");
        }
      } catch {}
    }
    return initial;
  });

  useEffect(() => {
    localStorage.setItem(
      "businessRegistrationData",
      JSON.stringify({ data: formData, timestamp: new Date().getTime() }),
    );
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      termsAccepted: e.target.checked,
      termsAcceptedAt: e.target.checked ? new Date() : null,
    }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    setStep(2);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.termsAccepted) {
      alert("Debes aceptar los términos y condiciones");
      return;
    }
    if (formData.password !== formData.confirm_password) {
      alert("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post("/api/register-bussines", formData);
      localStorage.removeItem("businessRegistrationData");
      navigate("/formulario-enviado");
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      {/* ── Header ── */}
      <div className={styles.pageHeader}>
        <div className={styles.headerInner}>
          <div className={styles.breadcrumb}>
            <Link to="/">Inicio</Link> / <span>Registro de Empresa</span>
          </div>

          <div className={styles.headerRow}>
            <div className={styles.headerLeft}>
              <h1>Registro de Empresa</h1>
              <p>Registrá tu organización para acceder a los servicios de salud corporativa.</p>
            </div>
            <span className={styles.loginHint}>
              ¿Ya tenés cuenta? <Link to="/login">Iniciá sesión →</Link>
            </span>
          </div>

          {/* Stepper */}
          <div className={styles.stepper}>
            <div className={`${styles.stepItem} ${step >= 1 ? styles.active : ""}`}>
              <div className={styles.stepCircle}>1</div>
              Datos de la empresa
            </div>
            <div className={styles.stepLine} />
            <div className={`${styles.stepItem} ${step === 2 ? styles.active : ""}`}>
              <div className={styles.stepCircle}>2</div>
              Contacto y acceso
            </div>
          </div>
        </div>
        {/* end headerInner */}
      </div>

      {/* ── Contenido ── */}
      <div className={styles.content}>
        <div className={styles.card}>
          {/* ────── PASO 1 ────── */}
          {step === 1 && (
            <form onSubmit={handleNext}>
              <p className={styles.stepLabel}>PASO 1 DE 2</p>
              <h2 className={styles.cardTitle}>Datos de la empresa</h2>
              <p className={styles.cardSubtitle}>Información institucional de tu organización.</p>

              <div className={styles.formGrid}>
                {/* Fila 1 */}
                <div className={styles.field}>
                  <label className={styles.label}>RAZÓN SOCIAL*</label>
                  <input
                    className={styles.input}
                    name="reason_social"
                    value={formData.reason_social}
                    onChange={handleChange}
                    placeholder="Razón social oficial"
                    required
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>NOMBRE COMERCIAL*</label>
                  <input
                    className={styles.input}
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Como aparecerá en la plataforma"
                    required
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>RUC</label>
                  <input
                    className={styles.input}
                    name="ruc"
                    value={formData.ruc}
                    onChange={handleChange}
                    placeholder="20XXXXXXXX"
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>PERSONA DE CONTACTO</label>
                  <input
                    className={styles.input}
                    name="contact_person"
                    value={formData.contact_person}
                    onChange={handleChange}
                    placeholder="Nombre completo"
                  />
                </div>

                {/* Fila 2 */}
                <div className={styles.field}>
                  <label className={styles.label}>CARGO</label>
                  <input
                    className={styles.input}
                    name="charges"
                    value={formData.charges}
                    onChange={handleChange}
                    placeholder="Ej. Gerente General"
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>PAÍS</label>
                  <input
                    className={styles.input}
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    placeholder="Perú"
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>DEPARTAMENTO</label>
                  <input
                    className={styles.input}
                    name="department"
                    value={formData.department}
                    onChange={handleChange}
                    placeholder=""
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>PROVINCIA</label>
                  <input
                    className={styles.input}
                    name="province"
                    value={formData.province}
                    onChange={handleChange}
                    placeholder=""
                  />
                </div>

                {/* Fila 3 */}
                <div className={styles.field}>
                  <label className={styles.label}>DISTRITO</label>
                  <input
                    className={styles.input}
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    placeholder=""
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>DIRECCIÓN</label>
                  <input
                    className={styles.input}
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder=""
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>TELÉFONO</label>
                  <input
                    className={styles.input}
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Ej. +51 999 999 999"
                  />
                </div>
                {/* celda vacía para mantener el grid */}
                <div />
              </div>

              <p className={styles.required}>* Campos obligatorios</p>

              <div className={styles.cardFooter}>
                <Link to="/" className={styles.btnBack}>
                  ← Volver al inicio
                </Link>
                <button type="submit" className={styles.btnNext}>
                  Siguiente →
                </button>
              </div>
            </form>
          )}

          {/* ────── PASO 2 ────── */}
          {step === 2 && (
            <form onSubmit={handleSubmit}>
              <p className={styles.stepLabel}>PASO 2 DE 2</p>
              <h2 className={styles.cardTitle}>Contacto y acceso</h2>
              <p className={styles.cardSubtitle}>
                Información de contacto y credenciales de acceso.
              </p>

              <div className={styles.formGrid}>
                <div className={styles.field}>
                  <label className={styles.label}>CORREO ELECTRÓNICO*</label>
                  <input
                    className={styles.input}
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="empresa@email.com"
                    required
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>TELÉFONO*</label>
                  <input
                    className={styles.input}
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+51 999 999 999"
                    required
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>SITIO WEB</label>
                  <input
                    className={styles.input}
                    type="url"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    placeholder="https://..."
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>DIRECCIÓN</label>
                  <input
                    className={styles.input}
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Av. Ejemplo 123"
                  />
                </div>
              </div>

              <div className={styles.formGrid2}>
                <div className={styles.field}>
                  <label className={styles.label}>CONTRASEÑA*</label>
                  <input
                    className={styles.input}
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Mínimo 8 caracteres"
                    required
                    minLength={8}
                  />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>CONFIRMAR CONTRASEÑA*</label>
                  <input
                    className={styles.input}
                    type="password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    placeholder="Repetir contraseña"
                    required
                    minLength={8}
                  />
                </div>
              </div>

              <p className={styles.required}>* Campos obligatorios</p>

              <div className={styles.cardFooter}>
                <button type="button" className={styles.btnBack} onClick={() => setStep(1)}>
                  ← Atrás
                </button>

                <div className={styles.cardFooterRight}>
                  <label className={styles.checkRow}>
                    <input
                      type="checkbox"
                      checked={formData.termsAccepted}
                      onChange={handleCheckboxChange}
                      required
                    />
                    Acepto los <Link to="/terminos-condiciones">términos y condiciones</Link> de
                    Vitalclic *
                  </label>

                  <button type="submit" className={styles.btnSubmit} disabled={loading}>
                    {loading ? (
                      <CircularProgress size={16} thickness={5} sx={{ color: "#fff" }} />
                    ) : (
                      "✓ REGISTRARME"
                    )}
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterEmpresa;
